import { render, staticRenderFns } from "./PosReportPayments.vue?vue&type=template&id=0da9372a"
import script from "./PosReportPayments.vue?vue&type=script&lang=js"
export * from "./PosReportPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports